<template>
  <svg viewBox="0 0 600 600" :class="{ active: changeColor }">
    <rect x="137.15" y="90.47" width="43.32" height="419.26" rx="15.39" ry="15.39" />
    <rect x="231.28" y="173.14" width="43.32" height="336.58" rx="15.37" ry="15.37" />
    <rect x="325.4" y="257.31" width="43.32" height="252.41" rx="15.88" ry="15.88" />
    <rect x="419.52" y="357.34" width="43.32" height="152.38" rx="15.22" ry="15.22" />
    <rect
      x="286.24"
      y="285.77"
      width="27.52"
      height="500"
      rx="13.76"
      ry="13.76"
      transform="translate(835.77 235.77) rotate(90)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    changeColor: {
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  rect {
    fill: $white;
  }
  &.active rect {
    fill: $white;
  }
}

.light svg {
  rect {
    fill: $gray-6;
  }

  &.active rect {
    fill: $white;
  }
}
</style>
